const TOKEN_KEY = 'jdsuit_token';
const TOKEN_EXPIRES_KEY = 'jdsuit_token_expires_at';
const DEFAULT_EXPIRES_MS = 30 * 24 * 60 * 60 * 1000; // 默认 30 天

export const getToken = (): string | null => {
  const token = localStorage.getItem(TOKEN_KEY);
  const expiresAt = localStorage.getItem(TOKEN_EXPIRES_KEY);
  if (!token) return null;
  if (expiresAt && Date.now() > Number(expiresAt)) {
    removeToken();
    return null;
  }
  return token;
};

export const setToken = (token: string, expiresInMs: number = DEFAULT_EXPIRES_MS): void => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(TOKEN_EXPIRES_KEY, String(Date.now() + expiresInMs));
};

export const removeToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXPIRES_KEY);
};
